import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedAdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#1F1A17] flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-[#C5A880] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user || !user.is_admin) {
    const redirectState = { from: location };
    return <Navigate to="/admin/login" replace state={redirectState} />;
  }

  return children;
};

export default ProtectedAdminRoute;
